import { request } from '@/shared/api/request'

export const remove = (payload) => {
	return request({ url: 'contract/sendDeletionData', method: 'DELETE', data: payload })
}